import React, { useEffect, useState } from 'react'
import toast from 'react-hot-toast';
import { AiOutlineLogout } from "react-icons/ai";
import { useNavigate } from 'react-router-dom';

export default function UserAccount() {
 let [data,setData]=useState([])

 async function getAPIData(){
    let res = await fetch("http://34.228.14.188:8000/api/user/"+ localStorage.getItem("userid"),{
      method:"GET",
    })
       res = await res.json()
       if(res.result==="Done"){
        console.log(res.data);
        
        setData(res.data)
       }
       else
         console.log("Result Not Found");
         
 }
 
 useEffect(()=>{
  getAPIData()
 },[])



  let navigate = useNavigate()
  let logout =()=>{
    localStorage.removeItem("login", true)
    localStorage.removeItem("name")
    localStorage.removeItem("userid")
    localStorage.removeItem("role")
    localStorage.removeItem("token") 
    localStorage.removeItem("email")
    toast.success("LogOut Has Been SuccessFully!")
    navigate("/")
    window.location.reload();
    
  }
  return (
    <div className="container-flulid">
            <div className="row">
                <div className="col-md-12 user-account ">
                    {
                      localStorage.getItem("role")==="@A*_s&_k!=!@h!-%"?
                      <h1> <sup>_____</sup> ADMIN ACCOUNT <sup>_____</sup> </h1>
                      :
                      <h1> <sup>_____</sup> MY ACCOUNT <sup>_____</sup> </h1>

                    }
                 <div className="user-name">
                 <span className='float-start span1 text-uppercase '>Hello,   {data.name}</span> <span className='float-end span2' onClick={logout}>LOG OUT <AiOutlineLogout /></span>
                 </div>
                 <hr />
                </div>

                
            </div>
        </div>
  )
}
